import createApiServices from "./createApiServices"
import { extendUrlFactory } from "../../views/helpers/extenent-url"

const isProduction = extendUrlFactory.url === 'https://factory.merchize.com'
const prefixURL = isProduction ? 'https://fulfillment.merchize.com/api/platform' : 'https://fulfillment-staging.merchize.com/api/platform'
const prefixURL2 = isProduction ? 'https://fulfillment.bymerchize.com' : 'https://fulfillment-staging.bymerchize.com'

const api = createApiServices({ baseUrl: prefixURL })
export const requestPhotoByOrder = (data) => {
    return api.makeAuthRequest({
        url: '/request-photo',
        method: 'POST',
        data,
    })
}

export const requestPhotoByPackages = (data) => {
    return api.makeAuthRequest({
        url: '/request-photo/by-packages',
        method: 'POST',
        data,
    })
}

export const uploadPhoto = (id, data) => {
    return api.makeAuthRequest({
        url: `/request-photo/${id}`,
        method: 'PUT',
        data,
    })
}

export const convertDownloadLink = (url, isLabel = false) => {
    const base64_s3_url = btoa(url)
    const targetURL = isLabel ? prefixURL2 : prefixURL
    return `${targetURL}/request-photo/get-photo-s3?s3_url=${encodeURIComponent(base64_s3_url)}`
}